import React from 'react'
import injectSheet from 'react-jss'
import Lottie from 'lottie-react'
import animData from './animations/loader1.json'
import mobileAnimData from './animations/loaderMobile.json'

const styleSheet = {
    loader: {
        position: 'absolute',
        top: '80px',
        left: ({ isDeviceMobile }) => (isDeviceMobile ? '' : '65px'),
        left: '50%',
        transform: ({ isDeviceMobile }) =>
            isDeviceMobile ? 'translateX(-50%) scale(0.5)' : 'translateX(-50%) scale(0.2)',
    },
}

const Loader = ({ classes, isDeviceMobile }) => {
    return (
        <div className={classes.loader}>
            <Lottie animationData={isDeviceMobile ? mobileAnimData : animData} loop={true} />
        </div>
    )
}

export default injectSheet(styleSheet)(Loader)
